import { render } from "./PortfolioItem.vue?vue&type=template&id=55651478&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=ts"
export * from "./PortfolioItem.vue?vue&type=script&lang=ts"

import "./PortfolioItem.vue?vue&type=style&index=0&id=55651478&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55651478"

export default script